import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { of } from 'rxjs';
import { catchError, map, switchMap } from 'rxjs/operators';
import {
    closeTicketSuccess,
    createTaskSuccess,
    deleteAttachmentSuccess,
    loadTicketHistory,
    loadTicketHistoryFailure,
    loadTicketHistorySuccess,
    reopenTicketSuccess,
    updateTaskNoteSuccess,
    updateTaskSuccess,
    updateTicketHistory,
    updateTicketHistoryFailure,
    updateTicketHistorySuccess,
    uploadAttachmentSuccess
} from 'src/app/root-store/ticket-store/actions/tickets.actions';
import { showToasterMessage } from 'src/app/shared/actions/toaster.actions';
import { HttpResponseHelpers } from 'src/app/shared/helpers';
import { TicketService } from 'src/app/travelx/tickets/ticket.service';

@Injectable()
export class TicketHistoryEffects {
    constructor(private readonly _actions$: Actions, private readonly _ticketService: TicketService) {}

    getTicketHistoryById$ = createEffect(() =>
        this._actions$.pipe(
            ofType(
                loadTicketHistory,
                updateTicketHistorySuccess,
                uploadAttachmentSuccess,
                createTaskSuccess,
                closeTicketSuccess,
                reopenTicketSuccess,
                updateTaskSuccess,
                updateTaskNoteSuccess,
                deleteAttachmentSuccess
            ),
            switchMap((action) => {
                return this._ticketService.getTicketHistory(action.ticketId).pipe(
                    map((result) => loadTicketHistorySuccess({ history: result })),
                    catchError((error) =>
                        of(loadTicketHistoryFailure({ error: HttpResponseHelpers.parseErrorResponse(error) }))
                    )
                );
            })
        )
    );

    createTicketHistory$ = createEffect(() =>
        this._actions$.pipe(
            ofType(updateTicketHistory),
            switchMap((action) => {
                return this._ticketService.createTicketHistory(action.ticketId, action.comment).pipe(
                    map(() =>
                        updateTicketHistorySuccess({
                            ticketId: action.ticketId,
                            message: 'Created Ticket History successfully'
                        })
                    ),
                    catchError((error) =>
                        of(updateTicketHistoryFailure({ error: HttpResponseHelpers.parseErrorResponse(error) }))
                    )
                );
            })
        )
    );

    showMessageSuccess$ = createEffect(() =>
        this._actions$.pipe(
            ofType(updateTicketHistorySuccess),
            map((action) => showToasterMessage({ message: action.message }))
        )
    );

    showMessageFailure$ = createEffect(() =>
        this._actions$.pipe(
            ofType(loadTicketHistoryFailure, updateTicketHistoryFailure),
            map((action) => showToasterMessage({ message: action.error as string }))
        )
    );
}
